<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="mx-2">
        <v-layout align-center column justify-center>
            <v-expansion-panel>
                <v-expansion-panel-content
                        :key="index"
                        v-for="(item, index) in $store.getters.checkedBooks">
                    <div slot="header">
                        <v-list-tile
                                :key="item.title">
                            <v-list-tile-avatar>
                                <v-btn color="primary" flat icon to="/statementBookList">
                                    <v-icon>book</v-icon>
                                </v-btn>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>
                                        <span class="black--text">
                                            [{{item.books.course.code}}] {{item.books.course.title}}
                                        </span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title class="text-truncate caption">
                                        <span class='text--primary'>
                                            {{item.books.course.professor}}
                                        </span>
                                    <span class="grey--text text--lighten-0">
                                            &mdash;Εξάμηνο {{item.books.course.semester}}
                                        </span><br/>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </div>

                    <v-card class="ml-5">
                        <v-card-text>
                            <div class="text-xs-left ml-4">
                                <v-layout row>
                                    <v-card @click="openDialog(item.books.books[0].book)"
                                            style="cursor: default"
                                            class="flex"
                                            flat
                                            tile>
                                        <v-card-title class="outline">
                                            <v-icon left>library_books</v-icon>
                                            <a>
                                                <u>
                                                [{{item.books.books[0].book.id}}]
                                                {{item.books.books[0].book.title}},
                                                Eκδοτες: {{item.books.books[0].book.publisherName}}
                                                </u>
                                            </a>
                                            <!----------------------Tooltips-------------------------------------------------------->

                                            <ToolTipComponent class="ml-2" v-if="util.checkToolTipId(item.books.books[0].book.id)" :bookId="item.books.books[0].book.id"/>

                                            <!----------------------Tooltips-------------------------------------------------------->
                                        </v-card-title>
                                    </v-card>

                                <!--<v-chip @click="openDialog(item.books.books[0].book)" class="pa-1" color="primary"-->
                                        <!--outline>-->
                                    <!--<v-icon left>library_books</v-icon>-->
                                    <!--[{{item.books.books[0].book.id}}]-->
                                    <!--{{item.books.books[0].book.title}},-->
                                    <!--Eκδοτες: {{item.books.books[0].book.publisherName}}-->

                                <!--</v-chip>-->

                                </v-layout>
                            </div>

                        </v-card-text>
                        <div v-if="$store.getters.listOfEbooksById[item.books.courseId] || $store.getters.listLinkedEbooks[item.books.courseId]">
                        <p class="ml-5"><i>Πρόσθετο διδακτικό υλικό (ηλεκτρονική μορφή)</i></p>
                        </div>
                        <v-flex>
                            <v-list>
                                <v-list-tile v-if="Object.keys($store.getters.listOfEbooksById).length > 0"
                                             class="ml-4"
                                             :key="j" :value="j"
                                             avatar
                                             v-for="(ebook, j) in $store.getters.listOfEbooksById[item.books.courseId]">

                                    <v-list-tile-content>
                                        <v-card @click="ebookDisplay(ebook)"
                                                style="cursor: default"
                                                class="flex"
                                                flat
                                                tile>
                                            <v-card-title class="outline">
                                                <v-icon left>picture_as_pdf</v-icon>
                                                <a href="#">{{ebook.title}}</a>
                                            </v-card-title>
                                        </v-card>
                                        <!--<v-chip @click="ebookDisplay(ebook.linkToPublisher)" class="pa-1" color="secondary"-->
                                                <!--outline>-->
                                            <!--<v-icon left>picture_as_pdf</v-icon>-->
                                            <!--{{ebook.title}}-->
                                        <!--</v-chip>-->
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="Object.keys($store.getters.listLinkedEbooks).length > 0"
                                             class="ml-4"
                                             :key="j" :value="j"
                                             avatar
                                             v-for="(ebook, j) in $store.getters.listLinkedEbooks[item.books.courseId]">

                                    <v-list-tile-content>
                                        <v-card @click="ebookDisplay(ebook.linkToPublisher)"
                                                style="cursor: default"
                                                class="flex"
                                                flat
                                                tile>
                                            <v-card-title class="outline">
                                                <v-icon left>picture_as_pdf</v-icon>
                                                <a href="#">{{ebook.title}}</a>
                                            </v-card-title>
                                        </v-card>
                                        <!--<v-chip @click="ebookDisplay(ebook.linkToPublisher)" class="pa-1" color="secondary"-->
                                        <!--outline>-->
                                        <!--<v-icon left>picture_as_pdf</v-icon>-->
                                        <!--{{ebook.title}}-->
                                        <!--</v-chip>-->
                                    </v-list-tile-content>
                                </v-list-tile>

                            </v-list>
                        </v-flex>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
    </div>
</template>

<script>

    import util from "../../utilities"
    import ToolTipComponent from "./ToolTipComponent";
    import requests from "../../requests";

    export default {
        name: "DeclarationBooksComponent",
        components: {ToolTipComponent},
        data() {
            return {
                util
            }
        },
        methods: {
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },
            closeDialog() {
                this.$store.commit('setDialog', false)
            },
	        ebookDisplay(item) {
		        if(item.type === 'ProfessorNotes'){
			        requests.putForFilesWithRetryIfNotSuccess('student/api/books/get-book-pdf', item, (errorMessage)=> {
				        if (errorMessage === '{error} Το αρχείο δεν βρέθηκε.') {
					        window.open(item.linkToPublisher, "_blank");
				        } else {
					        var storeObj = {
						        title: 'Σφάλμα!',
						        text: errorMessage,
						        color: 'indianRed',
						        class: 'white--text indianRed text-center justify-center'
					        };

					        this.$store.commit('setErrorPopup', true);
					        this.$store.commit('setErrorPopupProps', storeObj);
					        this.$store.commit('setLoadingModal', false);
				        }
			        });
		        } else if(item.type === 'eBook'){
			        window.open(item.linkToPublisher, "_blank");
		        }
            }
        }
    }
</script>

<style scoped>

</style>
